var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.085 9.848h-1.89l.021-.73c-1.917-.245-3.247-1.085-3.137-2.083.11-1 1.497-1.84 3.253-2.09l.023-.793 1.632-.003.012.745c1.051.083 2.015.374 2.712.834l-1.241.498c-.512-.34-1.27-.535-2.088-.534-1.418.003-2.611.604-2.662 1.341-.049.738 1.146 1.336 2.664 1.336.987 0 1.89-.26 2.352-.677l1.49.408c-.627.578-1.803.966-3.152 1.066l.011.682Zm8.155-2.835C21.24 4.797 17.157 3 12.12 3 7.084 3 3 4.797 3 7.013l.001.007v1.03c0 2.215 4.082 4.012 9.12 4.012 5.036 0 9.119-1.797 9.119-4.013l-.001-.01h.001V7.013Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.12 14.518c-4.67 0-8.513-1.544-9.049-3.536a1.762 1.762 0 0 0-.071.475l.001.007H3v1.029c0 2.217 4.084 4.012 9.12 4.012 5.037 0 9.12-1.795 9.12-4.012l-.001-.01v-1.026c0-.161-.027-.32-.07-.475-.535 1.992-4.38 3.536-9.049 3.536"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.12 18.962c-4.67 0-8.513-1.545-9.049-3.537a1.762 1.762 0 0 0-.071.476l.001.006H3v1.029c0 2.217 4.084 4.013 9.12 4.013 5.037 0 9.12-1.796 9.12-4.013l-.001-.01v-1.025c0-.162-.027-.32-.07-.476-.535 1.992-4.38 3.537-9.049 3.537"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStake);
export default __webpack_public_path__ + "static/media/Stake.bdc74a4377bb3a3d302e41f92fd1eee6.svg";
export { ForwardRef as ReactComponent };